const DOWNLOAD_ITEMS = [
  { label: '第 092 期 · 综艺圈节点', size: '12.4 MB', format: 'ZIP / PDF' },
  { label: '第 091 期 · 直播话题对照', size: '10.8 MB', format: 'ZIP / PDF' },
  { label: '八月整月归档包', size: '86.2 MB', format: 'ZIP' },
];

export default function DownloadBand() {
  return (
    <section id="download" className="w-full px-4 md:px-8 py-12 md:py-20">
      <div className="relative w-full overflow-hidden rounded-lg bg-foreground-950">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Stylized%20editorial%20scene%20of%20neatly%20stacked%20archive%20paper%20boxes%20and%20folded%20cream%20newsprint%20in%20deep%20maroon%20and%20warm%20amber%20tones%2C%20soft%20dramatic%20side%20lighting%20with%20long%20shadows%2C%20subtle%20texture%2C%20abstract%20minimal%20composition%20with%20clean%20uncluttered%20background%20space&width=1600&height=700&seq=mag17-dl-001&orientation=landscape"
            alt="17.cn黑料合集 归档下载"
            title="17.cn黑料合集 整期归档下载"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/30" />

        <div className="relative z-10 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 px-5 md:px-12 py-10 md:py-16">
          <div className="lg:col-span-7">
            <span className="text-xs font-label tracking-[0.3em] text-accent-300">08 / 归档下载</span>
            <h3 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-background-50">
              整期打包，离线也能慢慢翻
            </h3>
            <p className="mt-4 max-w-xl text-sm leading-7 text-background-100/85">
              不想一条条点开？把整期合集一次性下载下来，按自己的节奏看。下载内容与站内条目保持同步，更新后重新下载即可获得最新版本。
            </p>
            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <a
                href="#download"
                className="inline-flex items-center justify-center gap-2 rounded-md bg-accent-500 px-6 py-3 text-sm font-label text-foreground-950 transition-colors hover:bg-accent-400 whitespace-nowrap cursor-pointer"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-download-2-line" />
                </span>
                下载最新整期
              </a>
              <a
                href="#archive"
                className="inline-flex items-center justify-center gap-2 rounded-md border border-background-50/40 px-6 py-3 text-sm font-label text-background-50 transition-colors hover:bg-background-50/10 whitespace-nowrap cursor-pointer"
              >
                浏览全部归档
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line" />
                </span>
              </a>
            </div>
          </div>

          <div className="lg:col-span-5">
            <ul className="space-y-3">
              {DOWNLOAD_ITEMS.map((item) => (
                <li
                  key={item.label}
                  className="flex items-center justify-between gap-4 rounded-md border border-background-50/20 bg-background-50/10 px-4 py-3 backdrop-blur-sm"
                >
                  <div className="min-w-0">
                    <p className="truncate text-sm font-label text-background-50">{item.label}</p>
                    <p className="mt-0.5 text-[11px] font-label text-background-100/70">
                      {item.format} · {item.size}
                    </p>
                  </div>
                  <a
                    href="#download"
                    aria-label={`下载 ${item.label}`}
                    className="w-9 h-9 shrink-0 flex items-center justify-center rounded-md bg-accent-500 text-foreground-950 transition-colors hover:bg-accent-400 cursor-pointer"
                  >
                    <i className="ri-download-line" />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}